import { FindOperation } from '@infuse/api/common';
import { MultiSelectOption } from '@infuse/ui/domain';
import { useQuery } from '@tanstack/vue-query';
import { computed, Ref } from 'vue';

export const useGenericRoleSelectOptions = ({
  apiFn,
  queryKeys,
  fetchParentId,
  enabled,
  onlyEnableWithParentId = false
}: {
  apiFn: (() => Promise<MultiSelectOption[]>) | FindOperation<MultiSelectOption[], string>;
  queryKeys: string[];
  fetchParentId?: Ref<string | undefined>;
  onlyEnableWithParentId?: boolean;
  enabled?: Ref<boolean>;
}) => {
  const query = useQuery<MultiSelectOption[]>({
    queryKey: [...queryKeys, fetchParentId?.value],
    enabled: () => (onlyEnableWithParentId ? !!fetchParentId?.value : enabled?.value),
    queryFn: () => {
      if (fetchParentId?.value) {
        return (apiFn as FindOperation<MultiSelectOption[], string>)({ id: fetchParentId.value });
      }

      return (apiFn as () => Promise<MultiSelectOption[]>)();
    }
  });

  const roles = computed(() => query.data.value);

  return {
    ...query,
    roles
  };
};
